<template>
  <div class="box">
    <Icon type="ios-alert-outline" size="128" style="color: red" />
    <h2 style="text-align: center">{{ $t("router.noPermission") }}</h2>
  </div>
</template>

<script>
export default {
  name: "no-jurisdiction",
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
